import {
  REPORTS_SAVE,
  CLAUSES_FETCH,
  REPORT_PUBLICATION,
  REPORT_VALIDATION,
  REPORT_PUBLICATION_SCHEDULE_BREAK_ACTIVE,
  // REPORT_GET_EDIT_SESSION,
  REPORT_CANCEL_DATA_FEED,
  FEATURES_GET_IMPORTED_COUNT,
  FEATURES_FETCH,
  MAP_SELECTION_APPLY
} from './actions.type';

import {
  REPORTS_RANGE_SELECTION_ACTIVATE,
  REPORTS_RANGE_SET,
  CLAUSES_SET,
  WINDOW_API_ERROR_SHOW,
  WINDOW_MIGRATION_ERROR_SHOW,
  REPORT_VALIDATION_ERRORS_SET,
  REPORT_VALIDATION_CHOOSEN_OBJECT_PROPERTIES_SET,
  REPORT_VALIDATION_PUBLISH_FINISHED_AUTOMATICALLY_SET,
  DATA_FEED_REPORT_LOADED_SET,
  REPORT_LOCKED_SET
} from './mutations.type';

import { Api as ApiRaporty } from '../api/api-raporty';
import { Api as ApiKlauzule } from '../api/api-klauzule';
import { Api as ApiSesjeEdycyjne } from '../api/api-sesje-edycyjne';
import { Api as ApiZasilenia } from '../api/api-zasilenia-masowe';
import { Api as ApiHarmonogramZasilen } from '../api/api-harmonogram-zasilen';

const reportApi = new ApiRaporty();
const clauseApi = new ApiKlauzule();
const editSessionApi = new ApiSesjeEdycyjne();
const dataFeedApi = new ApiZasilenia();
const dataFeedScheduleApi = new ApiHarmonogramZasilen();

const initialState = {
  generatedReportId: undefined,
  rangeSelectionActive: false,
  selectedRange: undefined,
  clauses: [],
  validationErrors: {
    count: 0,
    errors: []
  },
  validationChoosenObject: undefined,
  publishFinishedAutomatically: false,
  dataFeedReportLoaded: false,
  clausesFetchInProgress: false,
  reportWizardLocked: false
};

var clausesControl = null;

export const state = Object.assign({}, initialState);

export const actions = {
  async [REPORTS_SAVE](context, report) {
    return reportApi.postRaporty({
      body: report
    });
  },
  async [CLAUSES_FETCH](context) {
    context.commit('setClausesFetchInProgress', true);
    let control = Date.now();
    clausesControl = control;

    try {
      let response = await clauseApi.getKlauzuleRaport({
        wso2_id: this.contextEmail ? this.contextEmail : null,
        orgid: this.contextOrganizationId ? this.contextOrganizationId : null,
        control: control
      });
      let clauses = response.body.klauzule;

      if (clausesControl.toString() === response.body.control) {
        context.commit(CLAUSES_SET, clauses);
        context.commit('setClausesFetchInProgress', false);
      }
    } catch (error) {
      context.commit(CLAUSES_SET, []);
      context.commit(WINDOW_API_ERROR_SHOW, error);
    }
  },
  async [REPORT_VALIDATION](context) {
    try {
      var editSession = context.getters.editSession;
      var result = await editSessionApi.getSesjeEdycyjneByIdWalidacja({
        id: editSession
      });

      if (result && result.body) {
        var errors = result.body.bledy_walidacji;

        context.commit(REPORT_VALIDATION_ERRORS_SET, errors);
        return true;
      }
    } catch (error) {
      context.commit(WINDOW_API_ERROR_SHOW, error);
      return true;
    }
  },
  async [REPORT_PUBLICATION_SCHEDULE_BREAK_ACTIVE](context) {
    try {
      const result = await dataFeedScheduleApi.getZasileniaDostepne();
      if (result) {
        return result;
      }
    } catch (error) {
      context.commit(WINDOW_API_ERROR_SHOW, error);
      return null;
    }
  },
  async [REPORT_PUBLICATION](context) {
    try {
      var editSession = context.getters.editSession;
      // var result = await editSessionApi.putSesjeEdycyjneByIdPublikuj({
      //   id: editSession,
      //   async: context.getters.editSessionType == 'manual' ? false : true
      // });
      var result = await editSessionApi.putSesjeEdycyjneByIdPublikuj({
        id: editSession,
        async: false
      });
      if (result) {
        if (
          result.body.bledy_walidacji &&
          result.body.bledy_walidacji.length > 0
        ) {
          context.commit(
            REPORT_VALIDATION_ERRORS_SET,
            result.body.bledy_walidacji
          );
          context.commit(
            WINDOW_API_ERROR_SHOW,
            'Niepowodzenie publikacji. Raport wciąż zawiera błędy.'
          );
          return false;
        }
        return true;
      }
    } catch (error) {
      context.commit(WINDOW_API_ERROR_SHOW, error);
      return false;
    }
  },
  // async [REPORT_GET_EDIT_SESSION](context) {
  //   try {
  //     var delay = 0;
  //     var dataFeedId = context.getters.dataFeedId;
  //     var intervalId = setTimeout(async function askForStatus() {
  //       const control = Date.now().toString();
  //       var result = await dataFeedApi.getZasilenieMasoweByIdStatus({
  //         id: dataFeedId,
  //         control: control
  //       });
  //       if (result && result.body.control == control) {
  //         if (result.body.status == 'oczekuje na publikacje') {
  //           if (result.body.sesja && result.body.sesja.id) {
  //
  //             if (errorsArray) {
  //               context.commit(REPORT_VALIDATION_ERRORS_SET, errorsArray);
  //               context.dispatch(FEATURES_GET_IMPORTED_COUNT);
  //
  //             }
  //             context.commit(DATA_FEED_REPORT_LOADED_SET, true);
  //           } else {
  //             context.commit(
  //               WINDOW_API_ERROR_SHOW,
  //               'Nie znaleziono powiązanej sesji edycyjnej'
  //             );
  //             context.commit(DATA_FEED_REPORT_LOADED_SET, true);
  //           }
  //         } else if (result.body.status == 'opublikowano') {
  //           context.commit(
  //             REPORT_VALIDATION_PUBLISH_FINISHED_AUTOMATICALLY_SET,
  //             true
  //           );
  //           context.commit(DATA_FEED_REPORT_LOADED_SET, true);
  //         } else if (result.body.status == 'niepowodzenie migracji') {
  //           if (result.body.error || result.body.error_filepath) {
  //             context.commit(WINDOW_MIGRATION_ERROR_SHOW, {
  //               status: 'Niepowodzenie migracji.',
  //               error: result.body.error,
  //               errorFilePath: result.body.error_filepath
  //             });
  //           } else {
  //             context.commit(WINDOW_API_ERROR_SHOW, 'Niepowodzenie migracji.');
  //           }

  //           context.commit(DATA_FEED_REPORT_LOADED_SET, true);
  //         } else {
  //           delay = 10000;
  //           intervalId = setTimeout(askForStatus, delay);
  //         }
  //       }
  //     }, 0);
  //   } catch (error) {
  //     context.commit(WINDOW_API_ERROR_SHOW, error);
  //     context.commit(DATA_FEED_REPORT_LOADED_SET, true);
  //   }
  // },
  async [REPORT_CANCEL_DATA_FEED](context) {
    try {
      var dataFeedId = context.getters.dataFeedId;
      var dataFeedType = context.getters.dataFeedType.toLowerCase();
      if (dataFeedId != null && dataFeedType != null) {
        if (dataFeedType === 'manualne') {
          await dataFeedApi.putZasilenieManualneById({
            id: dataFeedId,
            body: {
              status: 'anulowano'
            }
          });
        } else if (dataFeedType === 'masowe') {
          await dataFeedApi.putZasileniaMasoweById({
            id: dataFeedId,
            body: {
              status: 'anulowano'
            }
          });
        } else {
          context.commit(WINDOW_API_ERROR_SHOW, 'Błąd anulowania zasilenia.');
        }
      } else {
        context.commit(WINDOW_API_ERROR_SHOW, 'Błąd anulowania zasilenia.');
      }
    } catch (error) {
      context.commit(WINDOW_API_ERROR_SHOW, error);
    }
  }
};

export const mutations = {
  [REPORTS_RANGE_SELECTION_ACTIVATE](state, active) {
    state.rangeSelectionActive = active;
  },
  [REPORTS_RANGE_SET](state, range) {
    state.selectedRange = range;
  },
  [CLAUSES_SET](state, clauses) {
    state.clauses = clauses;
  },
  [REPORT_VALIDATION_ERRORS_SET](state, errors) {
    state.validationErrors.count = errors.length;
    state.validationErrors.errors = errors.map(el => ({
      featureId: typeof el.feature == 'undefined' ? null : el.feature.id,
      id: el.regula.id,
      name: el.regula.nazwa,
      description: el.regula.opis,
      type: el.type,
      isGeoError: el.regula.geometria,
      fields: el.regula.pola
    }));
  },
  [REPORT_VALIDATION_CHOOSEN_OBJECT_PROPERTIES_SET](state, obj) {
    state.validationChoosenObject = obj;
  },
  [REPORT_VALIDATION_PUBLISH_FINISHED_AUTOMATICALLY_SET](state, finished) {
    state.publishFinishedAutomatically = finished;
  },
  [DATA_FEED_REPORT_LOADED_SET](state, isLoaded) {
    state.dataFeedReportLoaded = isLoaded;
  },
  setClausesFetchInProgress(state, value) {
    state.clausesFetchInProgress = value;
  },
  [REPORT_LOCKED_SET](state, value) {
    state.reportWizardLocked = value;
  }
};

export const getters = {
  rangeSelectionActive(state) {
    return state.rangeSelectionActive;
  },
  selectedRange(state) {
    return state.selectedRange;
  },
  clauses(state) {
    return state.clauses;
  },
  validationErrors(state) {
    return state.validationErrors;
  },
  validationChoosenObject(state) {
    return state.validationChoosenObject;
  },
  publishFinishedAutomatically(state) {
    return state.publishFinishedAutomatically;
  },
  initDataFeedReportLoaded(state) {
    return state.dataFeedReportLoaded;
  },
  clausesFetchInProgress(state) {
    return state.clausesFetchInProgress;
  },
  reportWizardLocked(state) {
    return state.reportWizardLocked;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
